import React, { useState, useEffect } from "react";
import { useStore } from "../stores/store.ts";

export const SimpleMapTooltip: React.FC = () => {
  const { tooltipText } = useStore();
  const [cursorX, setCursorX] = useState(0);
  const [cursorY, setCursorY] = useState(0);

  useEffect(() => {
    const onMouseMove = (e: any) => {
      setCursorX(e.clientX);
      setCursorY(e.clientY);
    };
    window.addEventListener("mousemove", onMouseMove);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  const tooltipStyle = {
    position: "fixed",
    top: cursorY + 20,
    left: cursorX + 20,
    zIndex: 1000,
    pointerEvents: "none",
    fontSize: "10px",
  } as React.CSSProperties;

  return tooltipText === "" ? null : (
    <div
      className="bg-white rounded-md max-w-32 border-gray-400 border p-0.5 text-center"
      style={tooltipStyle}
    >
      <span>{tooltipText}</span>
    </div>
  );
};
